import React from "react";
import { PlanUpdateForm } from "@components";

const PlanUpdate = ({ history }) => {
  return <PlanUpdateForm />;
};

export default PlanUpdate;
